import React from "react";
import { useParams } from "react-router-dom";

import Loading from "ui/Loading";
import NewWorkbookButton from "features/Workbooks/NewWorkbookButton";
import WorkbookListTable from "features/Workbooks/WorkbookListTable";

import { useWorkbooksForServerGroupQuery } from "./gql/Query.generated";

const ServerGroupWorkbookList = () => {
  const { serverGroupId } = useParams();
  const { loading, error, data, refetch } = useWorkbooksForServerGroupQuery({
    variables: { serverGroupId },
  });

  if (loading || error || !data) {
    return <Loading error={!!error} />;
  }

  return (
    <WorkbookListTable
      workbooks={data.getWorkbooks}
      showServerColumn
      showDatabaseColumn
      onDeleted={() => {
        refetch();
      }}
      toolbar={<NewWorkbookButton />}
    />
  );
};

export default ServerGroupWorkbookList;
